<div class="fm-authentication">
  <div class="container-fluid fm-container-full">
    <div class="row h-100 justify-content-center align-items-center">
      <div class="col-sm-10 col-md-8 col-lg-6 col-xl-5">
        <div class="fm-auth-card">

          <!-- Logo -->
          <div class="fm-logo mb-4 text-center">
            <a routerLink="/"><img src="images/logo.svg" width="200" alt="Forever Memories" /></a>
          </div>

          <!-- Loading State -->
          @if (isLoading()) {
            <div class="fm-verify-loader text-center">
              <div class="fm-verify-spinner">
                <div class="fm-spinner-logo">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                  </svg>
                </div>
              </div>
              <h3 class="fm-head-28 fm-head-sty2 fw-title fw-bold">Verifying Your Email</h3>
              <p>Please wait while we verify your email address...</p>
            </div>
          }

          <!-- Success State -->
          @else if (isVerified()) {
            <div class="text-center fm-auth-chead">
              <div class="fm-verify-icon success">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <h3 class="fm-head-28 fm-head-sty2 fw-title fw-bold">Email Verified Successfully!</h3>
              <p class="text-muted">Your email has been verified. Redirecting you to set up your Family Space...</p>
              <div class="fm-countdown-badge">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                Redirecting in {{ countdown() }}s
              </div>
            </div>
          }

          <!-- Failed State -->
          @else if (isFailed()) {
            <div class="text-center fm-auth-chead">
              <div class="fm-verify-icon failed">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="15" y1="9" x2="9" y2="15"></line>
                  <line x1="9" y1="9" x2="15" y2="15"></line>
                </svg>
              </div>
              <h3 class="fm-head-28 fm-head-sty2 fw-title fw-bold">Verification Failed</h3>
              <p class="text-muted">The verification link is invalid or has expired. Please request a new link or sign in.</p>
              <div class="fm-countdown-badge">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                Redirecting to login in {{ countdown() }}s
              </div>
            </div>
          }

          <!-- No Token — Manual Resend -->
          @else if (verificationStep() === 'manual') {
            <div class="fm-auth-chead">
              <h3 class="fm-head-28 fm-head-sty2 fw-title fw-bold">Verify Your Email</h3>
              <p>We've sent a verification link to your email. Please click the link to verify your account.</p>
            </div>
            <div class="fm-signin-form mt-4">
              <p class="text-muted mb-3">Didn't receive the email or link expired?</p>
              <form [formGroup]="resendForm" (ngSubmit)="onResendVerification()" novalidate>
                <fieldset class="row g-3 g-sm-4">
                  <div class="col-12">
                    <div class="form-group">
                      <label class="fm-label">Email Address <span class="fm-required">*</span></label>
                      <input
                        type="email"
                        placeholder="Enter your email address"
                        class="form-control"
                        [class.is-invalid]="f['email'].invalid && f['email'].touched"
                        formControlName="email"
                        autocomplete="email" />
                      @if (f['email'].errors?.['required'] && f['email'].touched) {
                        <div class="invalid-feedback">Email is required.</div>
                      }
                      @if (f['email'].errors?.['email'] && f['email'].touched) {
                        <div class="invalid-feedback">Please enter a valid email.</div>
                      }
                    </div>
                  </div>
                  <div class="col-12">
                    <button
                      class="fm-common-btn w-100 mt-2 mt-lg-3"
                      type="submit"
                      [disabled]="isLoading()">
                      @if (isLoading()) {
                        <span class="spinner-border spinner-border-sm me-2" role="status"></span>Sending...
                      } @else {
                        Resend Verification Link
                      }
                    </button>
                  </div>
                  <div class="col-12 text-center">
                    <p class="text-muted small">
                      Remember your password?
                      <a routerLink="/login" class="fm-basic-link">Back to Sign In</a>
                    </p>
                  </div>
                </fieldset>
              </form>
            </div>
          }

        </div>
      </div>
    </div>
  </div>
</div>
